import { CommonAlertService } from './../../services/common-alert.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-alert',
  templateUrl: './common-alert.component.html',
  styleUrls: ['./common-alert.component.scss']
})
export class CommonAlertComponent implements OnInit {

  public show = false;
  public errorMsg = {
    class: '',
    msg: '',
    message: ''
  };

  constructor(public alertService: CommonAlertService) { }

  ngOnInit() {
    this.alertService.alert.subscribe( alrtObj => {
      this.show = true;
      this.errorMsg = alrtObj;
      setTimeout(() => {
        this.show = false;
      }, 5000);
    });
  }
}
